const $ = require("jquery");

const Modal = {
    alert: function (message) {
        const $modal = $('.general.alert.modal');
        $modal.find('.content').text(message);

        $modal.modal({
            closable: false
        });

        $modal.modal('show');
    },
    confirm: function (message, cb) {
        const $modal = $('.general.confirm.modal');
        $modal.find('.content').text(message);

        $modal.modal({
            closable: false,
            onApprove: function () {
                cb(true);
            },
            onDeny: function () {
                cb(false);
            }
        });

        $modal.modal('show');
    }
};

export default Modal;